import React from "react";
import imgProductLakay from '../Layout/imgs/md3.jpg'
import Vote from './commentaire/vote'
import { elakayFromNow } from "../../utils/elakayDate";
import { orderStatusLabel } from "../pages/purchased/OrderStatusBadge";
import { isAuthenticated, updateItem, removeItem } from "../auth";
import { MdDelete} from "react-icons/md";
import { FaPlus, FaMinus} from "react-icons/fa";
import { FiDelete } from "react-icons/fi";
import Price from "./productsPrice"
import ShippingCart from "./shippingCart";
import ShowimagesLoading from "./showImagesLoading";

const buildCarrierTrackingUrl = (carrier, trackingNumber) => {
    const tracking = encodeURIComponent(String(trackingNumber || "").trim());
    if (!tracking) return "";

    const normalizedCarrier = String(carrier || "").trim().toLowerCase();
    if (normalizedCarrier.includes("usps")) {
        return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}`;
    }
    if (normalizedCarrier.includes("ups")) {
        return `https://www.ups.com/track?tracknum=${tracking}`;
    }
    if (normalizedCarrier.includes("fedex")) {
        return `https://www.fedex.com/fedextrack/?trknbr=${tracking}`;
    }
    if (normalizedCarrier.includes("dhl")) {
        return `https://webtrack.dhlglobalmail.com/?trackingnumber=${tracking}`;
    }
    if (normalizedCarrier.includes("ontrac")) {
        return `https://www.ontrac.com/tracking/?number=${tracking}`;
    }

    return "";
};

const trackingUrlForCustomer = (orderProduct) => {
    const delivery = orderProduct?.products?.delivery || {};
    const info = orderProduct?.products?.info || {};
    const carrier = delivery.carrierCode || delivery.carrierName || info.carrier;
    const tracking = delivery.trackingNumber || info.tracking;

    return String(
        delivery.trackingUrl
        || info.urlTracking
        || buildCarrierTrackingUrl(carrier, tracking)
        || ""
    ).trim();
};
 
const CardOrders = ({
    product,
    laguangeElakay,
    infoSource,
    orderURL,
    feetShip = 1.3,
    setShowTrakingOrder,
    setTrackingOrder,
    setShowItermOrder,
    bnt = false,
    bntOderView 
}) => {

    const translatedText = (section, key, fallback) => {
        const languageApi = infoSource?.languageAPI;
        const fromInfoSource = infoSource?.laguangeElakay?.(section, languageApi)?.[key];
        const fromProp = typeof laguangeElakay === "function"
            ? laguangeElakay(section, languageApi)?.[key]
            : null;
        return fromInfoSource || fromProp || fallback;
    };

    const ProductName = () => {
        const text = product?.prod_name || product?.products?.productID?.name || "Product";
        const TruncatedText = infoSource?.TruncatedText;
        return TruncatedText
            ? <TruncatedText text={text} limits={[40, 30]} showToggle={true} />
            : <span>{text}</span>;
    };

    // Styles CSS Premium Ultra Modernes
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes cardEnter {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes statusPulse {
    0%, 100% {
        box-shadow: 0 0 0 0 currentColor;
    }
    50% {
        box-shadow: 0 0 0 4px currentColor;
    }
}

@keyframes imageZoom {
    from {
        transform: scale(1);
    }
    to {
        transform: scale(1.05);
    }
}

/* ===== ORDER CARD PREMIUM ===== */

.order-card-premium {
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(20px);
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 
        0 4px 20px rgba(0, 115, 153, 0.08),
        0 0 0 1px rgba(226, 232, 240, 0.6);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    animation: cardEnter 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    position: relative;
    margin-top: 0.75rem;
    min-height: auto;
}

.order-card-premium::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.03) 0%, 
        transparent 50%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.order-card-premium:hover {
    box-shadow: 
        0 12px 40px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(0, 164, 216, 0.3);
    transform: translateY(-4px);
}

.order-card-premium:hover::before {
    opacity: 1;
}

/* ===== CARD BODY - MÊME STRUCTURE SUR TOUS LES DEVICES ===== */

.order-card-body {
    display: grid;
    grid-template-columns: 160px 1fr auto;
    gap: 1.5rem;
    padding: 1.5rem;
    position: relative;
    align-items: start;
}

/* ===== IMAGE SECTION ===== */

.order-image-container {
    width: 160px;
    height: 160px;
    border-radius: 16px;
    overflow: hidden;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    box-shadow: 
        0 4px 16px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    flex-shrink: 0;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.order-image-container::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.1) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
}

.order-card-premium:hover .order-image-container {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.order-card-premium:hover .order-image-container::before {
    opacity: 1;
}

.order-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.order-card-premium:hover .order-image-container img {
    transform: scale(1.08);
}

/* ===== INFO SECTION ===== */

.order-info-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    min-width: 0;
    flex: 1;
}

/* Product Name */
.order-product-name {
    color: #1e293b;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.4;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.3s ease;
}

.order-product-name:hover {
    color: #007399;
}

/* Price Section */
.order-price-container {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

/* Amount Display */
.order-amount {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: 
        linear-gradient(135deg, 
            rgba(239, 68, 68, 0.08) 0%, 
            rgba(220, 38, 38, 0.05) 100%
        );
    padding: 0.5rem 1rem;
    border-radius: 12px;
    font-weight: 700;
    font-size: 1.25rem;
    color: #dc2626;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.15);
    transition: all 0.3s ease;
}

.order-amount:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.order-amount::before {
    content: '💰';
    font-size: 1.125rem;
}

/* Vote Section */
.order-vote-container {
    display: inline-flex;
    align-items: center;
    background: 
        linear-gradient(135deg, 
            rgba(255, 193, 7, 0.1) 0%, 
            rgba(255, 152, 0, 0.05) 100%
        );
    padding: 0.375rem 0.75rem;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(255, 193, 7, 0.15);
}

/* Status Badge */
.order-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 12px;
    font-weight: 700;
    font-size: 0.8125rem;
    line-height: 1.2;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    position: relative;
    overflow: hidden;
}

.order-status-badge::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.order-status-badge:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.order-status-badge:hover::before {
    opacity: 1;
}

/* Status Colors */
.status-not-processed {
    background: linear-gradient(135deg, #64748b 0%, #475569 100%);
    color: white;
}

.status-processing {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: white;
}

.status-shipped {
    background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
    color: white;
}

.status-delivered {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
}

.status-cancelled {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
}

.status-return {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    color: white;
}

.status-replace {
    background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
    color: white;
}

/* Timestamp */
.order-timestamp {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #64748b;
    font-size: 0.875rem;
    font-weight: 600;
}

.order-timestamp::before {
    content: '🕐';
    font-size: 1rem;
}

/* ===== ACTIONS SECTION ===== */

.order-actions-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-end;
    justify-content: space-between;
    min-width: 140px;
}

/* Buttons */
.btn-order-premium {
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 700;
    font-size: 0.9375rem;
    border: none;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: none;
}

.btn-order-premium::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

/* View Order Button */
.btn-view-order {
    background: 
        linear-gradient(135deg, 
            rgba(248, 250, 252, 0.98) 0%, 
            rgba(241, 245, 249, 0.95) 100%
        );
    color: #1e293b;
    box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.btn-view-order::before {
    background: linear-gradient(135deg, 
        rgba(148, 163, 184, 0.1) 0%, 
        transparent 100%
    );
}

.btn-view-order:hover {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    color: #0f172a;
}

.btn-view-order:hover::before {
    opacity: 1;
}

/* Checkout Button */
.btn-checkout {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    color: white;
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.btn-checkout::before {
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.2) 0%, 
        transparent 100%
    );
}

.btn-checkout:hover {
    background: linear-gradient(135deg, #006b8a 0%, #007399 100%);
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 115, 153, 0.4);
}

.btn-checkout:hover::before {
    opacity: 1;
}

/* Tracking Button */
.btn-tracking {
    background: 
        linear-gradient(135deg, 
            rgba(248, 250, 252, 0.98) 0%, 
            rgba(241, 245, 249, 0.95) 100%
        );
    color: #475569;
    box-shadow: 
        0 3px 10px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    font-size: 0.875rem;
    padding: 0.625rem 1.25rem;
}

.btn-tracking::before {
    content: '📦';
    font-size: 1rem;
}

.btn-tracking:hover {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    color: #1e293b;
}

/* ===== RESPONSIVE - GARDE LA MÊME STRUCTURE GRID ===== */

@media (max-width: 768px) {
    /* MOBILE - GARDE GRID 3 COLONNES */
    .order-card-body {
        grid-template-columns: 100px 1fr 100px;
        gap: 0.75rem;
        padding: 1rem;
        align-items: start;
    }

    .order-image-container {
        width: 100px;
        height: 100px;
    }

    .order-actions-section {
        min-width: 100px;
        gap: 0.5rem;
    }

    .order-product-name {
        font-size: 0.9375rem;
    }

    .order-amount {
        font-size: 1rem;
        padding: 0.375rem 0.75rem;
    }

    .btn-order-premium {
        padding: 0.625rem 1rem;
        font-size: 0.875rem;
    }

    .btn-tracking {
        padding: 0.5rem 0.875rem;
        font-size: 0.8125rem;
    }

    .order-status-badge {
        font-size: 0.75rem;
        padding: 0.375rem 0.75rem;
    }

    .order-timestamp {
        font-size: 0.8125rem;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    /* TABLET - GARDE GRID 3 COLONNES */
    .order-card-body {
        grid-template-columns: 120px 1fr 120px;
        gap: 1rem;
        padding: 1.25rem;
    }

    .order-image-container {
        width: 120px;
        height: 120px;
    }

    .order-actions-section {
        min-width: 120px;
    }
}

@media (min-width: 1025px) {
    /* DESKTOP - GRID 3 COLONNES */
    .order-card-body {
        grid-template-columns: 160px 1fr 140px;
        gap: 1.5rem;
        padding: 1.5rem;
    }

    .order-image-container {
        width: 160px;
        height: 160px;
    }

    .order-actions-section {
        min-width: 140px;
    }
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
        animation: none !important;
        transition: none !important;
    }
}

/* ===== ACCESSIBILITY ===== */

.btn-order-premium:focus-visible {
    outline: 3px solid #00a4d8;
    outline-offset: 2px;
}

.order-card-premium:focus-within {
    box-shadow: 
        0 12px 40px rgba(0, 115, 153, 0.15),
        0 0 0 3px rgba(0, 164, 216, 0.3);
}

/* Screen reader only */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

/* ===== SHIMMER EFFECT ===== */

.shimmer-loading {
    background: 
        linear-gradient(
            90deg,
            rgba(248, 250, 252, 0) 0%,
            rgba(226, 232, 240, 0.8) 50%,
            rgba(248, 250, 252, 0) 100%
        );
    background-size: 200% 100%;
    animation: shimmerGlow 2s infinite;
}
`;

    const sum = (total, num) => (
        total + Math.round(num)
    )

    const sumVote = product?.products?.productID && Array.isArray(product?.prod_vote)
        ? product.prod_vote.map((p) => p.voteNum)
        : [];
    const rating = sumVote.length ? sumVote.reduce(sum, 0) / sumVote.length : 0;

    const showVote = rating > 0 ? true : false

    const voteView = (
        showVote && (
            <div className="order-vote-container">
                <Vote rating={parseFloat(rating)} />
            </div>
        )
    )

    const checkQuantity = (Q)=>{
        return  Q === 0 ? 0 : 1
    }

    const CheckTaxZone = (tax)=>{
        return  tax ? tax.EstimatedCombinedRate : 0.088750
    }

    const ItemsOrder = () => {
        return product && product.products && [product.products].reduce((currentValue, nextValue) => {
            return currentValue + (nextValue.count * (nextValue.price * (100 - nextValue.salePrice)/100))
        }, 0);
    };

    const ShippingOrder = () => {
        return product && product.products && [product.products].reduce((currentValue, nextValue) => {
            return product[0].shipping ? 0 : currentValue + (5 * feetShip)
        }, 0);
    };

    const TaxOrder = () => {
        return product && product.products && [product.products].reduce((currentValue, nextValue) => {
            return currentValue + (checkQuantity(nextValue.quantity) * nextValue.count *(nextValue.price * (100 - nextValue.salePrice) / 100) * CheckTaxZone(nextValue.taxprodZone))
        }, 0);
    };

    const getTotal = () => {
        // Amount actually authorized for this line (items + shipping + tax
        // from the server snapshot) whenever the order has it.
        const charged = product?.products?.payment?.amountCents
        if (Number.isInteger(charged) && charged > 0) return (charged / 100).toFixed(2)
        let a = ItemsOrder()
        let c = TaxOrder()
        let d = a  + c
        return parseFloat(d).toFixed(2) 
    };

    const getStatusClass = (status) => {
        const statusMap = {
            "Not processed": "status-not-processed",
            "Processing": "status-processing",
            "Shipped": "status-shipped",
            "Delivered": "status-delivered",
            "Cancelled": "status-cancelled",
            "Return or replace": "status-return",
            "Replace": "status-replace"
        };
        return statusMap[status] || "status-not-processed";
    };

    const getStatusIcon = (status) => {
        const iconMap = {
            "Not processed": "⏳",
            "Processing": "⚙️",
            "Shipped": "🚚",
            "Delivered": "✅",
            "Cancelled": "❌",
            "Return or replace": "🔄",
            "Replace": "♻️"
        };
        return iconMap[status] || "📦";
    };

    return (
        <>
            <style>{premiumStyles}</style>
            <div className="order-card-premium">
                <div className="order-card-body">
                    {/* Image Section */}
                    <div className="order-image-container">
                        <ShowimagesLoading
                            src={product.products.urlImg}
                            alt={product?.prod_name || product?.products?.productID?.name || "Product"}
                            width={160}
                            height={160}
                        />
                    </div>
                    
                    {/* Info Section */}
                    <div className="order-info-section">
                        <h3 className="order-product-name">
                             <ProductName />
                            {/* {product.products.productID && product.prod_name} */}
                        </h3>
                        
                        <div className="order-price-container">
                            <Price
                                showAddToCartButton={false}
                                products={product.products}
                            />
                            {voteView}
                        </div>

                        <div className="order-amount">
                            <span>{translatedText('label', 'amount', 'Amount')}</span>
                            <strong>${parseFloat(getTotal()).toFixed(2)}</strong>
                        </div>

                        <div className="order-timestamp">
                            <span>
                                {translatedText('title', 'orderer', 'Ordered')}
                            </span>
                            <span>{elakayFromNow(product.createdAt)}</span>
                        </div>

                        <span className={`order-status-badge ${getStatusClass(product.products.status)}`}>
                            <span>{getStatusIcon(product.products.status)}</span>
                            <span>{orderStatusLabel(product.products.status)}</span>
                        </span>

                        {!bnt && (
	                            <button
	                                className="btn-order-premium btn-tracking"
	                                onClick={()=>{
	                                    setShowTrakingOrder(true);
	                                    // Order Tracking Display task: the modal now fetches the
	                                    // server-normalized tracking (steps/iframe/both) itself via
	                                    // orderId/orderProductId -- trackingUrl is kept only as the
	                                    // instant, already-known fallback so the modal is never blank
	                                    // while that request is in flight.
	                                    setTrackingOrder({
	                                        trackingUrl: trackingUrlForCustomer(product) || null,
	                                        orderId: product.orders_id,
	                                        orderProductId: product.products._id
	                                    })
	                                }}
	                            >
                                {translatedText('title', 'tchakingnumber', 'Tracking number')}
                            </button>
                        )}
                    </div>
                    
                    {/* Actions Section */}
                    <div className="order-actions-section">
                        {bnt && product.products.status === "Not processed" ? (
                            <button
                                type="button"
                                className="btn-order-premium btn-checkout"
                                onClick={()=> bntOderView(product.orders_id, product.products.productID, product.products._id)}
                            >
                                <span>💳</span>
                                <span>{translatedText('title', 'checkout', 'Checkout')}</span>
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn-order-premium btn-view-order"
                                onClick={()=> bntOderView(product.orders_id, product.products.productID, product.products._id)}
                            >
                                <span>👁️</span>
                                <span>{translatedText('Button', 'viewOrder', 'View order')}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CardOrders;
